<template lang="pug">
#app(v-bind:class="{force96: rateRel < 0.9}")
  #navbar.Montserrat.center(v-if="!isMobile && $route.name != 'Client'")
    a(href="/" v-on:click.prevent.stop="$router.push('/#app')")
      img(src="./assets/LNH_HeaderImage.png")
    span
      a#A-Leading-Brands(href="#LeadingBrands" v-on:click.prevent.stop="$router.push('/#LeadingBrands')") ABOUT
    span
      a#A-Our-Work(href="/OurWork" v-on:click="goToWork()") WORK
    //- span
    //-   a#A-Hispanic(href="/Hipspanic" v-on:click.prevent.stop="$router.push('/Hipspanic')") HIPSPANIC<sup>&reg;</sup>
    span
      a#A-Capabilities(href="/#NewCapabilities" v-on:click.prevent.stop="$router.push('/#NewCapabilities')") CAPABILITIES
    span
      a#A-Founders(href="/#Founders" v-on:click.prevent.stop="$router.push('/#Founders')") FOUNDERS
    span
      a(v-on:click="$router.push('#Contact')") SAY HI
  #navbarMobile.Montserrat.center(v-if="isMobile" v-bind:class="{blackHeader: $route.hash !='#Home' && ($route.name == 'Mobile' || $route.path == '/OurWork' || $route.name == 'Work')}")
    img#mainLogo(src="./assets/desktop/landing/2024/Desktop_HomePage_Logo.png" v-if="($route.path == '/OurWork' || $route.name == 'Work' || $route.hash == '#Founders' || $route.hash == '#Contact' || $route.hash == '#NewCapabilities') && $route.hash != '#Hipspanic'" v-on:click="$router.push('/mobile#Home');")
    img#mainLogo(src="./assets/hipspanic_r.png" v-if="($route.path == '/mobile' || $route.path == '/OurWork' || $route.name == 'Work') && $route.hash == '#Hipspanic'")
    a#MobileMenu.menu(v-on:click="menuActive = !menuActive" v-bind:class="{active: menuActive}")
      span
    #MobileMenuDiv(v-bind:class="{active: menuActive}")
      .container
        p.Fjalla(v-bind:class="{blueHeader: $route.hash =='#Home'}" v-on:click="$router.push('/mobile#Home'); menuActive = false; scrollTop()") HOME
        p.Fjalla(v-bind:class="{blueHeader: $route.path == '/OurWork' || $route.name == 'Work'}" v-on:click="goToWork()") WORK
        p.Fjalla(v-bind:class="{blueHeader: $route.hash =='#NewCapabilities'}" v-on:click="$router.push('/mobile#NewCapabilities'); menuActive = false; scrollTop()") CAPABILITIES
        p.Fjalla(v-bind:class="{blueHeader: $route.hash =='#Founders'}" v-on:click="$router.push('/mobile#Founders'); menuActive = false; scrollTop()") FOUNDERS
        p.Fjalla(v-bind:class="{blueHeader: $route.hash =='#Contact'}" v-on:click="$router.push('/mobile#Contact'); menuActive = false; scrollTop()") SAY HI
  router-view
  #Contact(v-bind:class="{mobile: isMobile}" v-if="$route.hash != '#Contact' || $route.name != 'Mobile'")
    .center
      img(src="./assets/desktop/landing/2024/Desktop_Footer_Logo.png")
      p.Montserrat(style="font-size:30%; font-weight:300") sup@loversnothaters.com
        br
        br
      div.CenterLinks
        a#A-Miami(href="/Miami" v-on:click.prevent.stop="goToMiami()") Miami.
        a#A-SanDiego(href="/SanDiego" v-on:click.prevent.stop="goToSanDiego()") San Diego.
        a#A-TheMetaverse(href="/#TheMetaverse" v-on:click.prevent.stop="goToTheMetaverse()") The Metaverse.
      br
</template>
<script>
console.log("Coded by Adolfo Reyna, with so much Love <3!");
window.$ = require("jquery");
var activeNav = false;
window.section = ["Home"];
$(window).scroll(function () {
  var scrollTop = $(window).scrollTop();
  var h = $(window).height();
  if (scrollTop > 20 != activeNav) {
    activeNav = scrollTop > 20;
    if ($("#navbar").hasClass("active") != activeNav) {
      if (activeNav) {
        $("#navbar").addClass("active");
      } else {
        $("#navbar").removeClass("active");
      }
    }
  }
});
export default {
  name: "app",
  data() {
    return {
      isMobile: false,
      menuActive: false,
      section: window.section,
      rateRel: window.innerWidth / window.innerHeight,
    };
  },
  mounted() {
    this.isMobile = window.screen.availWidth < 740;
    window.addEventListener("resize", () => {
      this.rateRel = window.innerWidth / window.innerHeight;
    });
    if (
      this.isMobile &&
      this.$route.name != "Mobile" &&
      this.$route.name != "Work" &&
      this.$route.name != "OurWork"
    )
      this.$router.push("/mobile#Home");
    //console.log(this.isMobile, this.$route.name != 'Mobile', this.$route.name != 'Work', this.$route.name)
  },
  methods: {
    scrollBootom() {
      window.scrollTo(0, document.documentElement.scrollHeight);
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
    goToWork() {
      this.$router.push("/OurWork");
      this.menuActive = false;
      this.scrollTop();
    },
    goToMiami() {
      const miamiUrl =
        "https://www.google.com/maps/place/Lovers+Not+Haters/@25.7678099,-80.2163659,17z/data=!3m1!4b1!4m5!3m4!1s0x88d9b76ba4e951d7:0xf06f30bf8d034db7!8m2!3d25.7677982!4d-80.2141768";
      let a = document.createElement("a");
      a.target = "_blank";
      a.href = miamiUrl;
      a.click();
    },
    goToSanDiego() {
      const SanDiegoUrl =
        "https://www.google.com/maps/place/WeWork+Office+Space+%26+Coworking/@32.8707247,-117.2289672,17z/data=!3m1!4b1!4m5!3m4!1s0x80dc06d3f0c1b371:0xe19cda1d74410fee!8m2!3d32.8707247!4d-117.2267785";
      let a = document.createElement("a");
      a.target = "_blank";
      a.href = SanDiegoUrl;
      a.click();
    },
    goToTheMetaverse() {},
  },
};
</script>

<style lang="sass">
@font-face
  font-family: "TradeGothicCondensed"
  src: url('~@/assets/fonts/TradeGothic/trade-gothic-bold-condensed-20.ttf')
@font-face
  font-family: "TradeGothicAltCondensed"
  src: url('~@/assets/fonts/TradeGothic/tradeGothic-18.ttf')
@font-face
  font-family: "GothamRegular"
  src: url('~@/assets/fonts/Gotham/Gotham Light Regular.otf')
@font-face
  font-family: "GothamItalic"
  src: url('~@/assets/fonts/Gotham/Gotham Light Italic.otf')
@import url('https://fonts.googleapis.com/css?family=Fjalla+One|Oswald:200,300,400|Montserrat:300,400,500,700')
html, body
  position: relative
  overflow-x: hidden
body
  font-size: 3.3vw
  text-rendering: optimizeLegibility
  -webkit-font-smoothing: antialiased
  color: rgb(5,5,5)
  width: 100vw
  overflow-x: hidden
a
  color: inherit
@media (max-device-width: 769px)
  .fullScreen
    min-height: calc(100vw / 16 * 10)
    margin-bottom: 0px
  .scaleAble
    transform-origin: left
    transform: scale(1.1)
  .responsive-break
    display: none
@media (min-device-width: 769px)
  .fullScreen
    min-height: 100vh
    margin-bottom: 0px
  .force96 .fullScreen
    min-height: calc(100vw / 16 * 10)
p
  //background-color: rgba(125,125,125,0.5)
  margin: 15px 0
.CenterLinks
  display: flex
  justify-content: center
sup
  font-size: 50%
  top: -1em
.Fjalla
  font-family: 'Fjalla One', sans-serif
  line-height: 0.77
  padding-top: 0.1em
.Oswald
  font-family: 'Oswald', Icons
  line-height: 0.75
  padding: 0
  padding-bottom: 0.09em
  font-weight: 300
  font-style: normal
.Montserrat
  font-family: 'Montserrat', sans-serif
  line-height: 0.77
  font-weight: bold
//.Fjalla
  font-family: 'Fjalla One', sans-serif
  line-height: 106%
  margin: 0px
//.Oswald
  font-family: 'Oswald', Icons
  line-height: 106%
  margin: 0px
  font-weight: 300
  font-style: normal
//.Montserrat
  font-family: 'Montserrat', sans-serif
  line-height: 106%
  margin: 0px
  font-weight: bold
.textGrey
  color: #747b89
.smallestSize
  font-size: 50%
.smallerSize
  font-size: 60%
.smallSize
  font-size: 70%
.normalishSize
  font-size: 85%
.normalSize
  font-size: 100%
.mediumSize
  font-size: 120%
.largeSize
  font-size: 130%
.largerSize
  font-size: 230%
.blackAndWhiteBox
  color: white
  background-color: black
.WhiteAndBlackBox
  color: black
  background-color: white
.AquaAndBlackBox
  color: black
  background-color: rgb(0, 255, 255)
.AquaAndBlackBox, .blackAndWhiteBox, .WhiteAndBlackBox
  line-height: 1.1
  padding: 0px 5px
  margin-bottom: 10px
  padding-top: 3px
.closeByLines
  margin: 9px 0
  //line-height: 0.8
.noSpaces
  margin: 0 !important
  padding: 0 !important
.thinText
  font-weight: 300
.boldText
  font-weight: 500
.paddingSides
  padding-left: 40px
  padding-right: 40px
.relative
  position: relative
.showHand
  cursor: hand
  cursor: pointer
#A-Miami,#A-SanDiego
  margin-right: 10px
  text-decoration: underline
#A-Miami,#A-SanDiego, #A-TheMetaverse
  font-size: 30%
  font-weight: 300
  font-family: 'Montserrat', sans-serif
  line-height: 0.77
#navbar
  position: fixed
  background-color: rgba(0,0,0,0)
  top: 0px
  color: white
  width: 100vw
  z-index: 100
  padding-left: 5px
  padding-right: 5px
  padding-bottom: 2.5vw
  padding-top: 1vw
  margin: 0
  line-height: 0
  transition: all 0.7s
  a
    transition: color 0.5s
    cursor: hand
    cursor: pointer
    &.active
      color: rgb(0, 255, 255)
    &:hover
      color: rgba(255,255,255,0.8)
  span
    font-size: 1vw
    font-weight: 800
    padding-left: 2.35vw
    padding-right: 2.35vw
  img
    position: absolute
    left: 2vw
    top: 50%
    width: 12vw
    transform: translate(0,-50%)
    opacity: 0
  &.active
    background-color: black
    img
      opacity: 1
#navbarMobile
  position: absolute
  top: 0
  left: 0
  width: 100vw
  padding: 50px
  z-index: 109
  background-color: rgba(0, 0, 0, 0)
  transition: all 0.7s
  &.blackHeader
    background-color: black
    padding-bottom: 25vw
  #mainLogo
    position: absolute
    top: 8vw
    left: 12vw
    width: 38vw
  #MobileMenu
    position: fixed
    top: 10vmin
    right: 8vmin
    color: white
    transform-origin: right top
    transform: scale(2)
    z-index: 110
  #MobileMenuDiv
    position: fixed
    background: rgba(20, 20, 20, 0.98)
    top: 0
    left: 0
    width: 100vw
    height: 100vh
    z-index: 109
    color: rgba(255, 255, 255, 0.75)
    padding-top: 12vmin
    padding-left: 8vw
    text-align: left
    font-size: 190%
    font-weight: normal
    opacity: 0
    //transform-origin: right top
    transform: scale(0) translate(0%, -100%)
    transition: all 0.5s
    p
      margin-bottom: 3vmin
      &.blueHeader
        color: rgb(0, 255, 255)
    &.active
      opacity: 1
      transform: scale(1)
#work
  margin: 0px
  padding: 0px
  max-height: 33vw
  overflow-y: hidden
  img
    width: 100%
  .title
    font-size: 1.6vw
    font-weight: 400
    color: rgba(255, 255, 255, 1)
    font-style: normal
    line-height: 1
    position: absolute
    z-index: 90
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    opacity: 0
    transition: opacity 0.5s
  &:after
    content: ''
    position: absolute
    width: 12vw
    bottom: 33%
    left: 50%
    border-bottom: 0.3vw solid #00FFFF
    transform: translate(-50%, -50%)
    z-index: 100
    opacity: 0
    transition: opacity 0.5s
  &:hover
    background-color: black
    .title, &:after
      opacity: 1
    img
      opacity: 0.4
  &.mobile
    background-color: black
    .title, &:after
      opacity: 1
      font-size: 79%
      text-shadow: 2px 4px 3px rgba(0,0,0,0.3);
    img
      opacity: 0.7
    &:after
      bottom: 28%
      width: 15vw
      border-bottom: 0.6vw solid #00FFFF
#Contact
  padding-top: 20px
  background-color: #DDD
  img
    width: 19vw
  &.mobile
    padding-top: 100px
    font-size: 300%
    img
      width: 50vw

.menu
	position: relative
	display:  inline-block
	width: 30px
	height: 30px
	margin: 25px

.menu span
	margin: 0 auto
	position: relative
	top: 12px

.menu span:before, .menu span:after
	position: absolute
	content: ''

.menu span, .menu span:before, .menu span:after
	width: 30px
	height: 4px
	background-color: rgba(155,155,155, 1)
	display: block

.menu span:before
	margin-top: -12px

.menu span:after
	margin-top: 12px

.menu span
	-webkit-transition-duration: 0s; transition-duration: 0s
	-webkit-transition-delay: 0.2s; transition-delay: 0.2s

.menu.active span
	background-color: rgba(0,0,0,0.0)
	-webkit-transition-delay: 0.2s; transition-delay: 0.2s

.menu span:before
	-webkit-transition-property: margin, -webkit-transform; transition-property: margin, transform
	-webkit-transition-duration: 0.2s; transition-duration: 0.2s
	-webkit-transition-delay: 0.2s, 0s; transition-delay: 0.2s, 0s

.menu.active span:before
	margin-top: 0
	-webkit-transform: rotate(45deg); transform: rotate(45deg)
	-webkit-transition-delay: 0s, 0.2s; transition-delay: 0s, 0.2s

.menu span:after
	-webkit-transition-property: margin, -webkit-transform; transition-property: margin, transform
	-webkit-transition-duration: 0.2s; transition-duration: 0.2s
	-webkit-transition-delay: 0.2s, 0s; transition-delay: 0.2s, 0s

.menu.active span:after
	margin-top: 0
	-webkit-transform: rotate(-45deg); transform: rotate(-45deg)
	-webkit-transition-delay: 0s, 0.2s; transition-delay: 0s, 0.2s
</style>



// WEBPACK FOOTER //
// src/App.vue